import BaseService from './baseService'; 

export class SecurityGroupsService extends BaseService {
    constructor(){
        const baseUrl = "/SecurityGroups";
        super(baseUrl);
    }  
} 